import { render, staticRenderFns } from "./Primary.vue?vue&type=template&id=9ec5b40a"
import script from "./Primary.vue?vue&type=script&lang=ts"
export * from "./Primary.vue?vue&type=script&lang=ts"
import style0 from "./Primary.vue?vue&type=style&index=0&id=9ec5b40a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports